module.exports = __webpack_public_path__ + "static/service-e96960ae75cecacfc6645b6c4a42baed.jpg";